import React, { Component } from "react";
import api from "../../config/api";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import {
  openModalDebitComp,
  valueAmountComp,
  debitsSelectedComp,
  debitsSelectedIDsComp,
  openSnackComp,
  openConfirmDialogComp,
  noMixedBankDataComp,
} from "../../actions";
import { bindActionCreators } from "redux";
import { withStyles } from "@material-ui/core/styles";
import { Grid, Button } from "@material-ui/core";
// import HeaderAppBar from "../../components/HeaderAppBar";
import HeaderUser from "../../components/HeaderUser";
import Footer from "../../components/Footer";
import ButtonTypeName from "../../components/ButtonTypeName";
import {CardDebit} from "../../components/CardDebit";
import LoadingDefault from "../../components/LoadingDefault";
import ContentNotLoaded from "../../components/ContentNotLoaded";
import Snackbar from "../../components/Snackbar";
import ConfirmDialog from "../../components/ConfirmDialog";
import ReportsNonMixedBanks from "../ReportsNonMixedBanks";
import { arrayRemoveItem } from "../../helper/arrayRemoveItem";

const styles = (theme) => ({
  container: {
    padding: "0px 30px 20px 30px",
    marginTop: "130px",
  },
  menuGroup: {
    display: "flex",
    width: "100%",
    marginTop: "10px",
    marginBottom: "30px",
    padding: "20px 0px 0px 0px",
  },
  linkGroup: {
    textDecoration: "none",
  },
  button: {
    color: "rgb(24, 116, 185)",
    fontSize: 17,
    background: "none",
    border: "none",
    boxShadow: "none",
  },
  debitsGroup: {
    width: "100%",
    display: "flex",
    padding: 15,
    justifyContent: "space-between",
  },
  debitDescription: {
    color: "#636363",
    [theme.breakpoints.up("lg")]: {},
  },
  buttonsGroup: {
    display: "flex",
  },
  cardItem: {
    padding: 15,
  },
  loadingDiv: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  marginBottom: {
    marginBottom: 40,
  },

  main: {
    maxWidth: 600,
  },
  printButton: {
    margin: "20px auto",
    display: "flex",
  },
  borderItem: {
    padding: 35,
    border: "1px solid #00000033",
  },
  header: {
    display: "flex",
    justifyContent: "space-around",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  headerImg: {
    width: 100,
    height: 100,
  },
  content: {
    display: "flex",
    flexDirection: "column",
    padding: "10px 0 30px 0",
  },
  contentTitle: {
    fontSize: 25,
    fontWeight: 500,
  },
  contentDescription: {
    fontSize: 21,
    fontWeight: 500,
  },
  dataReportItem: {
    margin: 4,
  },
  bankItem: {
    display: "flex",
    alignItems: "center",
    margin: 2,
  },
  dot: {
    width: 5,
    height: 5,
    marginRight: 6,
    background: "#000",
    borderRadius: "50%",
  },
  divider: {
    width: "100%",
  },
});

const ButtonCleanBackground = withStyles((theme) => ({
  root: {
    float: "right",
    background: "none",
    color: "#699E42",
    fontSize: 16,
    borderRadius: 1,
    marginLeft: 10,
    width: 165,
    height: 62,
    boxShadow: "-2px 4px 5px 0px rgba(0, 0, 0, 0.1)",
    "&:hover": {
      color: "#fff",
      background: "#699E42",
    },
    [theme.breakpoints.down("sm")]: {
      margin: "10px 0px",
    },
  },
  checked: {},
}))((props) => <Button color="default" {...props} />);

export class Debit extends Component {
  constructor(props) {
    super(props);
    this.getItensDA = this.getItensDA.bind(this);
    this.getBanksList = this.getBanksList.bind(this);

    this.state = {
      debits: [],
      debitsSelected: [],
      banksList: [],
      loading: false,
      openDialog: false,
      RemoveDABankMist: false,
      showWindowPortal: false,
    };
  }

  componentDidMount() {
    this.props.openSnackComp(false);
    this.props.valueAmountComp(0);
    this.props.debitsSelectedComp([]);
    this.props.debitsSelectedIDsComp([]);

    this.props.valueAmountComp(0);
    this.setState({
      loading: true,
    });

    this.getItensDA();
    this.getBanksList();
  }

  async getItensDA() {
    const debitsList = [];
    await api
      .get("Debitos/ObterItensDA")
      .then((res) => {
        if (res.data.length > 0) {
          res.data.map((deb) => {
            return debitsList.push(deb);
          });
          if (debitsList.length > 0) {
            debitsList.forEach((item) => {
              item.DataReferenciaConvertida = this.convertDate(
                item.DataReferencia
              );
              item.DataVencimentoConvertida = this.convertDate(
                item.DataVencimento
              );
              if (item.Solicitacao !== null) {
                item.Solicitacao.DataAdesaoConvertida = this.convertDate(
                  item.Solicitacao.DataAdesao
                );
              }

              //APAGAR ISSO DEPOIS
              if (item.ValorOriginal === null) {
                item.ValorOriginalVirgula = (0)
                  .toFixed(2)
                  .replace(".", ",")
                  .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
              } else if (item.ValorOriginal >= 0) {
                item.ValorOriginalVirgula = item.ValorOriginal.toFixed(2)
                  .replace(".", ",")
                  .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
              }
              if (item.ValorCorrecao === null) {
                item.ValorCorrecaoVirgula = (0)
                  .toFixed(2)
                  .replace(/\d(?=(\d{3})+\.)/g, "$&,");
              } else if (item.ValorCorrecao >= 0) {
                item.ValorCorrecaoVirgula = item.ValorCorrecao.toFixed(
                  2
                ).replace(/\d(?=(\d{3})+\.)/g, "$&,");
              }
              if (item.ValorMulta === null) {
                item.ValorMultaVirgula = (0)
                  .toFixed(2)
                  .replace(/\d(?=(\d{3})+\.)/g, "$&,");
              } else if (item.ValorMulta >= 0) {
                item.ValorMultaVirgula = item.ValorMulta.toFixed(2).replace(
                  /\d(?=(\d{3})+\.)/g,
                  "$&,"
                );
              }
              if (item.ValorMultaInfracao === null) {
                item.ValorMultaInfracaoVirgula = (0)
                  .toFixed(2)
                  .replace(/\d(?=(\d{3})+\.)/g, "$&,");
              } else if (item.ValorMultaInfracao >= 0) {
                item.ValorMultaInfracaoVirgula = item.ValorMultaInfracao.toFixed(
                  2
                ).replace(/\d(?=(\d{3})+\.)/g, "$&,");
              }
              if (item.ValorJuros === null) {
                item.ValorJurosVirgula = (0)
                  .toFixed(2)
                  .replace(/\d(?=(\d{3})+\.)/g, "$&,");
              } else if (item.ValorJuros >= 0) {
                item.ValorJurosVirgula = item.ValorJuros.toFixed(2).replace(
                  /\d(?=(\d{3})+\.)/g,
                  "$&,"
                );
              }
              if (item.ValorHonorarios === null) {
                item.ValorHonorariosVirgula = (0)
                  .toFixed(2)
                  .replace(/\d(?=(\d{3})+\.)/g, "$&,");
              } else if (item.ValorHonorarios >= 0) {
                item.ValorHonorariosVirgula = item.ValorHonorarios.toFixed(
                  2
                ).replace(/\d(?=(\d{3})+\.)/g, "$&,");
              }
              if (item.ValorDesconto === null) {
                item.ValorDescontoVirgula = (0)
                  .toFixed(2)
                  .replace(/\d(?=(\d{3})+\.)/g, "$&,");
              } else if (item.ValorDesconto >= 0) {
                item.ValorDescontoVirgula = item.ValorDesconto.toFixed(
                  2
                ).replace(/\d(?=(\d{3})+\.)/g, "$&,");
              }
              if (item.ValorPagar === null) {
                item.ValorPagarVirgula = (0)
                  .toFixed(2)
                  .replace(/\d(?=(\d{3})+\.)/g, "$&,");
              } else if (item.ValorPagar >= 0) {
                item.ValorPagarVirgula = item.ValorPagar.toFixed(2).replace(
                  /\d(?=(\d{3})+\.)/g,
                  "$&,"
                );
              }
            });
          }
          this.setState({
            debits: debitsList,
            loading: false,
          });
        }
      })
      .catch((error) => {
        if (error.response.status === 500) {
          this.setState({
            error:
              "Servidor indisponível no momento, tente novamente mais tarde",
            loading: false,
          });
        } else if (error.response.status === 404) {
          this.setState({
            error: "Item não encontrado",
            loading: false,
          });
        } else {
          this.setState({
            error: error.response.data.error_description,
            loading: false,
          });
        }
      });
  }

  async getBanksList() {
    try {
      const banksGroup = await api.get("Bancos/Consultar?opcao=2");

      if (banksGroup.data.length > 0) {
        this.setState({
          banksList: banksGroup.data,
        });
      }
    } catch (error) {
      if (error.response.status >= 500) {
        this.setState({
          error: "Servidor indisponível no momento, tente novamente mais tarde",
          loading: false,
        });
      } else if (error.response.status === 404) {
        this.setState({
          error: "Item não encontrado",
          loading: false,
        });
      } else {
        this.setState({
          error: error.response.data.error_description,
          loading: false,
        });
      }
    }
  }

  convertDate = (date) => {
    if (date) {
      const dateToConvert = new Date(date);
      const day = dateToConvert.getDate();
      let month = dateToConvert.getMonth() + 1;
      const year = dateToConvert.getFullYear();

      if (month < 10) {
        month = "0" + month;
      }

      return day + "/" + month + "/" + year;
    }
  };

  handleGetCardSelected = (id, checked) => {
    if (checked) {
      this.setState((prevState) => ({
        debitsSelected: [...prevState.debitsSelected, id],
      }));
    } else {
      let removeItem = this.state.debitsSelected;
      removeItem = arrayRemoveItem(removeItem, id);

      this.setState({
        debitsSelected: removeItem,
      });
    }
  };

  handleChangeQuotas = () => {
    if (this.state.debitsSelected.length > 0) {
      let debitsGroup = this.getObjectDebit();
      let items = debitsGroup.filter((item) => item.Solicitacao !== null);

      if (items.length === debitsGroup.length) {
        this.props.debitsSelectedComp(debitsGroup);
        this.props.debitsSelectedIDsComp(this.state.debitsSelected);

        const { from } = this.props.location.state || {
          from: { pathname: "/alterar-cotas" },
        };
        this.props.history.push(from);
      } else {
        this.setState(
          {
            msg:
              "Você deve selecionar apenas debito(s) cadastrado(s) em débito automático",
          },
          () => {
            this.props.openSnackComp(true);
          }
        );
      }
    } else {
      this.setState(
        {
          msg: "Você deve selecionar ao menos um débito",
        },
        () => {
          this.props.openSnackComp(true);
        }
      );
    }
  };

  handleRemoveDebitAutomatic = () => {
    if (this.state.debitsSelected.length === 1) {
      let debitsGroup = this.getObjectDebit();

      //Verifica se o débito selecionado já possui vinculo com débito automático
      let items = debitsGroup.filter((item) => item.Solicitacao === null);

      if (items.length > 0) {
        this.setState(
          {
            msg:
              "Você só pode descadastrar itens vinculados a débito automático.",
          },
          () => {
            this.props.openSnackComp(true);
          }
        );
      } else {
        let banksGroup = this.state.banksList;
        const debitsItem = debitsGroup[0].Solicitacao.CodigoBanco;

        let bankSelected = null;
        banksGroup.forEach((item) => {
          if (item.CodigoBanco === debitsItem) {
            bankSelected = item;
          }
        });

        this.setState(
          {
            openDialog: true,
            RemoveDABankMist: bankSelected.PermiteCadastramentoMisto,
          },
          () => {
            this.props.openConfirmDialogComp(true);
          }
        );
      }
    } else {
      this.setState(
        {
          msg: "Somente 1 débito deve ser selecionado para o descadastramento",
        },
        () => {
          this.props.openSnackComp(true);
        }
      );
    }
  };

  handleConfirmRemoveDA = () => {
    let debits = {
      Ids: this.state.debitsSelected,
    };
    let debitsGroup = this.getObjectDebit();

    api
      .post("Debitos/DescadastrarDebitoAutomatico", debits)
      .then((removeDebitGroup) => {
        if (removeDebitGroup.data.Erros.length > 0) {
          this.setState(
            {
              msg: removeDebitGroup.data.Erros[0],
            },
            () => {
              this.props.openSnackComp(true);
            }
          );
        } else {
          this.props.noMixedBankDataComp(debitsGroup);
          this.setState(
            {
              msg: "Débitos descadastrado com sucesso!",
              openDialog: false,
            },
            () => {
              this.props.openSnackComp(true);
              this.props.openConfirmDialogComp(false);
              this.handleOpenPoupUp();
            }
          );
        }
      })
      .catch((error) => {});
  };

  handleOpenPoupUp = () => {
    this.setState((state) => ({
      ...state,
      showWindowPortal: !state.showWindowPortal,
    }));
  };

  handleRegisterDebitAutomatic = () => {
    if (this.state.debitsSelected.length > 0) {
      let debits = this.getObjectDebit();
      let items = debits.filter((item) => item.Solicitacao === null);

      if (items.length === debits.length) {
        this.props.debitsSelectedComp(debits);
        this.props.debitsSelectedIDsComp(this.state.debitsSelected);

        const { from } = this.props.location.state || {
          from: { pathname: "/cadastrar-debito-automatico" },
        };
        this.props.history.push(from);
      } else {
        this.setState(
          {
            msg:
              "Você deve selecionar apenas itens não vinculados a débito automático",
          },
          () => {
            this.props.openSnackComp(true);
          }
        );
      }
    } else {
      this.setState(
        {
          msg: "Você deve selecionar ao menos um débito",
        },
        () => {
          this.props.openSnackComp(true);
        }
      );
    }
  };

  getObjectDebit = () => {
    return this.state.debits.filter((x) =>
      this.state.debitsSelected.includes(x.IdItem)
    );
  };

  render() {
    const { classes } = this.props;
    const { debits, loading } = this.state;

    return (
      <div>
        <HeaderUser />

        <Snackbar message={this.state.msg} />

        <ConfirmDialog
          openDialog={this.state.openDialog}
          bankItem={this.state.RemoveDABankMist}
          handleConfirmRemoveDA={this.handleConfirmRemoveDA}
        />

        <Grid container className={classes.container}>
          <div className={classes.menuGroup}>
            <Link to="/" className={classes.linkGroup}>
              <Button variant="contained" className={classes.button}>
                <span>{"<"} VOLTAR</span>
              </Button>
            </Link>
          </div>

          <div className={classes.debitsGroup}>
            <div className={classes.debitDescription}>
              <p>
                Para adicionar um tributo em débito automático selecione o mesmo
                e clique em cadastrar. Clicando em descadastrar você remove os
                tributos selecionados do débito automático e em Alterar cotas
                você pode escolher se o débito deve ser em cota única ou em
                parcelas.
              </p>
            </div>
            <div className={classes.buttonsGroup}>
              <div onClick={this.handleChangeQuotas}>
                <ButtonCleanBackground>Alterar Cotas</ButtonCleanBackground>
              </div>

              <div onClick={this.handleRemoveDebitAutomatic}>
                <ButtonCleanBackground>Descadastrar</ButtonCleanBackground>
              </div>

              <div onClick={this.handleRegisterDebitAutomatic}>
                <ButtonTypeName typeButton={4} />
              </div>
            </div>
          </div>

          {loading && (
            <div className={classes.loadingDiv}>
              <LoadingDefault typeLoading={"card"} />
            </div>
          )}

          {debits.length === 0 && !loading && (
            <ContentNotLoaded
              message={"Não foram encontrados débitos no sistema."}
            />
          )}
          <div className={"automaticDebitsGrid"}>
            <Grid container>
              {this.state.debits.map((item) => {
                return (
                  <CardDebit
                    key={item.IdItem}
                    classes={classes}
                    handleGetCardSelected={this.handleGetCardSelected}
                    contentCard={item}
                    typeCard={"tribute"}
                    typePage={"debitAutomatic"}
                  />
                );
              })}
            </Grid>
          </div>
        </Grid>
        {this.state.showWindowPortal && (
          <ReportsNonMixedBanks>
            {/* <Grid container className={classes.container}>
              <div className={classes.main}>
                <button
                  className={classes.printButton}
                  onClick={() => window.print()}
                >
                  IMPRIMIR
                </button>

                <div className={classes.borderItem}>
                  <Grid item xs={12} sm={12} md={12} elevation={0}>
                    <div className={classes.header}>
                      <img
                        alt="Logo Prefeitura Pomba"
                        src={logoPrefeituraPomba}
                        className={classes.headerImg}
                      />
                      <div>
                        <p>
                          <strong>PMS</strong> - PREFEITURA MUNICIPAL DE
                          SALVADOR
                        </p>
                        <p>
                          <strong>SEFAZ</strong> - SECRETARIA MUNICIPAL DA
                          FAZENDA
                        </p>
                        <p>
                          <strong>SEQ</strong> - SETOR DE QUALIDADE
                        </p>
                      </div>
                    </div>
                  </Grid>
                  <Divider className={classes.divider} />
                  <Grid item xs={12} sm={12} md={12} elevation={0}>
                    <div className={classes.content}>
                      <h1 className={classes.contentTitle}>
                        CÓDIGO DE IDENTIFICAÇÃO PARA @Model.TítuloRelatorio DO
                        DÉBITO AUTOMÁTICO
                      </h1>
                      {this.props.noMixedBankDataValue.map(item => {
                        return (
                          <div>
                            <p className={classes.dataReportItem}>
                              <strong>Receita: </strong>
                              <span>{item.Tributo.Nome}</span>
                            </p>

                           {item.Contribuinte.TipoInscricao === 3 && (
                              <p className={classes.dataReportItem}>
                                <strong>Estabelecimento: </strong>{" "}
                                <span>
                                  {item.Contribuinte.NumInscricaoFormatado}
                                </span>
                              </p>
                            )}

                            {item.Contribuinte.TipoInscricao === 4 && (
                              <p className={classes.dataReportItem}>
                                <strong>Inscrição Mobiliária: </strong>{" "}
                                <span>
                                  {item.Contribuinte.NumInscricaoFormatado}
                                </span>
                              </p>
                            )}

                            {item.Contribuinte.TipoInscricao === 5 && (
                              <p className={classes.dataReportItem}>
                                <strong>Nº Documento Fiscal: </strong>{" "}
                                <span>
                                  {item.Contribuinte.NumInscricaoFormatado}
                                </span>
                              </p>
                            )}

                            {item.Contribuinte.TipoInscricao === 6 && (
                              <p className={classes.dataReportItem}>
                                <strong>Nº Parcelamento: </strong>{" "}
                                <span>
                                  {item.Contribuinte.NumInscricaoFormatado}
                                </span>
                              </p>
                            )}

                            {item.Contribuinte.TipoInscricao !== 3 &&
                              item.Contribuinte.TipoInscricao !== 4 &&
                              item.Contribuinte.TipoInscricao !== 5 && (
                                <p className={classes.dataReportItem}>
                                  <strong>Nº Inscrição: </strong>{" "}
                                  <span>
                                    {item.Contribuinte.NumInscricaoFormatado}
                                  </span>
                                </p>
                              )}

                            <p className={classes.dataReportItem}>
                              <strong>Contribuinte: </strong>
                              <span>{item.Contribuinte.NumInscricao}</span>
                            </p>
                            <p className={classes.dataReportItem}>
                              <strong>Código: </strong>{" "}
                              <span>
                                <strong>{item.IdItem}</strong>
                              </span>
                            </p>
                          </div>
                        );
                      })}
                    </div>
                  </Grid>

                  <Divider className={classes.divider} />
                  <Grid item xs={12} sm={12} md={12} elevation={0}>
                    <div className={classes.content}>
                      <h1 className={classes.contentTitle}>Observações:</h1>
                      <p style={{ margin: "0 0 20px 0" }}>
                        Rede Bancária credenciada * para o serviço de Dèbito
                        Automático
                      </p>

                      {this.state.banksList.map(item => {
                        return (
                          <p className={classes.bankItem}>
                            <div className={classes.dot} /> {item.Descricao}
                          </p>
                        );
                      })}
                      <p style={{ margin: "40px 0 0 0" }}>
                        * Em breve outros Bancos da Rede Bancária
                        disponibilizarão pagamentos em Débito Automático.
                      </p>
                    </div>
                  </Grid>
                </div>
              </div>
            </Grid> */}
          </ReportsNonMixedBanks>
        )}

        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (store) => ({
  openModalDebit: store.cardDebitState.openModalDebitValue,
  debitsSelectedValue: store.cardDebitState.debitsSelectedValue,
  valueAmountValue: store.cardDebitState.valueAmountValue,
  openSnackValue: store.cardDebitState.openSnackValue,
  noMixedBankDataValue: store.cardDebitState.noMixedBankDataValue,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      openModalDebitComp,
      valueAmountComp,
      debitsSelectedComp,
      debitsSelectedIDsComp,
      openSnackComp,
      openConfirmDialogComp,
      noMixedBankDataComp,
    },
    dispatch
  );

export default withStyles(styles, { withTheme: true })(
  connect(mapStateToProps, mapDispatchToProps)(Debit)
);
